<div class="shila-po">
  <header class="shila-po-head">
    <h2 class="shila-po-title">{{ "translate.shilaPo.title" | translate }}</h2>
    <div class="shila-po-search">
      <i class="fas fa-search" aria-hidden="true"></i>
      <input
        class="t-input t-input--colored"
        [ngModel]="filter"
        (ngModelChange)="filterBy($event)"
        [placeholder]="'translate.shilaPo.searchPatient' | translate"
        [attr.aria-label]="'translate.shilaPo.searchPatient' | translate"
      />
      <button
        *ngIf="filter"
        type="button"
        class="shila-po-clear"
        [attr.aria-label]="'translate.shilaPo.clearFilter' | translate"
        [title]="'translate.shilaPo.clearFilter' | translate"
        (click)="filterBy('')"
      >
        <i class="fas fa-times" aria-hidden="true"></i>
      </button>
    </div>
  </header>

  <div class="shila-po-body t-scrollbar">
    <section *ngIf="dentistStep && !dentistHidden" class="shila-po-dentist">
      <h3 class="shila-po-sectionTitle">
        {{
          (dentistStep.outcome === "SEVERAL" ? "translate.shilaPo.dentist.severalTitle" : "translate.shilaPo.dentist.unknownTitle")
            | translate: { name: dentistStep.shilaName }
        }}
      </h3>

      <div *ngIf="dentistStep.outcome === 'UNKNOWN'" class="shila-po-dentist-modes">
        <button
          type="button"
          class="shila-po-dentist-mode"
          [class.is-active]="dentistMode === 'existing'"
          (click)="setDentistMode('existing')"
        >
          {{ "translate.shilaPo.dentist.existing" | translate }}
        </button>
        <button type="button" class="shila-po-dentist-mode" [class.is-active]="dentistMode === 'new'" (click)="setDentistMode('new')">
          {{ "translate.shilaPo.dentist.new" | translate }}
        </button>
      </div>

      <ng-container *ngIf="dentistStep.outcome === 'SEVERAL'">
        <div class="shila-po-dentist-list">
          <ng-container *ngTemplateOutlet="candidateRows; context: { $implicit: dentistStep.candidates }"></ng-container>
        </div>
      </ng-container>

      <ng-container *ngIf="dentistStep.outcome === 'UNKNOWN' && dentistMode === 'existing'">
        <input
          class="t-input t-input--colored shila-po-dentist-search"
          [(ngModel)]="dentistFilter"
          (ngModelChange)="groupDoctors()"
          [placeholder]="'translate.shilaPo.dentist.search' | translate"
          [attr.aria-label]="'translate.shilaPo.dentist.search' | translate"
        />
        <div class="shila-po-dentist-list">
          <ng-container *ngFor="let group of [groups.atClinic, groups.others]; let i = index">
            <h4 *ngIf="group.length" class="shila-po-dentist-group">
              {{ (i === 0 ? "translate.shilaPo.dentist.atClinic" : "translate.shilaPo.dentist.others") | translate }}
            </h4>
            <button
              *ngFor="let doctor of group"
              type="button"
              class="shila-po-dentist-row"
              [class.is-selected]="pickedDoctorId === +doctor.id"
              (click)="pickDentist(+doctor.id)"
            >
              {{ doctor.text }}
            </button>
          </ng-container>
        </div>
      </ng-container>

      <ng-container *ngIf="dentistStep.outcome === 'UNKNOWN' && dentistMode === 'new'">
        <ng-container *ngIf="dentistStep.candidates.length">
          <h4 class="shila-po-dentist-group">{{ "translate.shilaPo.dentist.similar" | translate }}</h4>
          <div class="shila-po-dentist-list shila-po-dentist-similar">
            <ng-container *ngTemplateOutlet="candidateRows; context: { $implicit: dentistStep.candidates }"></ng-container>
          </div>
        </ng-container>
        <div class="shila-po-dentist-form">
          <label>
            <span>{{ "translate.shilaPo.dentist.name" | translate }}</span>
            <input class="t-input t-input--colored shila-po-dentist-name" maxlength="100" [(ngModel)]="newDentist.wholeName" />
          </label>
          <label>
            <span>{{ "translate.shilaPo.dentist.phone" | translate }}</span>
            <input class="t-input t-input--colored shila-po-dentist-phone" maxlength="14" dir="ltr" [(ngModel)]="newDentist.phone" />
          </label>
          <label>
            <span>{{ "translate.shilaPo.dentist.idNumber" | translate }}</span>
            <input class="t-input t-input--colored shila-po-dentist-idNumber" maxlength="10" dir="ltr" [(ngModel)]="newDentist.idNumber" />
          </label>
        </div>
      </ng-container>

      <div class="shila-po-dentist-actions">
        <button type="button" class="t-button-outline shila-po-dentist-later" (click)="dentistHidden = true">
          {{ "translate.shilaPo.dentist.later" | translate }}
        </button>
        <button
          *ngIf="dentistStep.outcome === 'SEVERAL' || dentistMode === 'existing' || pickedDoctorId !== null"
          type="button"
          class="t-button--success shila-po-dentist-choose"
          [disabled]="busy || pickedDoctorId === null"
          (click)="chooseDentist()"
        >
          {{ "translate.shilaPo.dentist.choose" | translate }}
        </button>
        <button
          *ngIf="dentistStep.outcome === 'UNKNOWN' && dentistMode === 'new'"
          type="button"
          class="t-button--success shila-po-dentist-create"
          [disabled]="!canCreateDentist"
          (click)="createDentist()"
        >
          {{ "translate.shilaPo.dentist.create" | translate }}
        </button>
      </div>
    </section>

    <section *ngIf="list.imported.length" class="shila-po-imported">
      <h3 class="shila-po-sectionTitle">{{ "translate.shilaPo.imported" | translate }}</h3>
      <div *ngFor="let po of list.imported" class="shila-po-card is-imported" [ngClass]="'is-' + po.status">
        <span class="shila-po-statusDot" aria-hidden="true"></span>
        <ng-container *ngTemplateOutlet="poHead; context: { $implicit: po, statusChip: true }"></ng-container>
        <button
          class="t-button-outline warn shila-po-release"
          [disabled]="busy || po.status === 'RELEASING'"
          (click)="release(po.poNumber)"
        >
          {{ "translate.shilaPo.release" | translate }}
        </button>
        <ng-container *ngTemplateOutlet="poItems; context: { $implicit: po }"></ng-container>
      </div>
    </section>

    <section class="shila-po-open">
      <h3 *ngIf="list.imported.length" class="shila-po-sectionTitle">{{ "translate.shilaPo.open" | translate }}</h3>
      <label
        *ngFor="let po of visiblePos"
        class="shila-po-card t-checkbox is-selectable"
        [class.is-selected]="selected.has(po.poNumber)"
        [class.is-RELEASING]="po.status === 'RELEASING'"
      >
        <span class="shila-po-check">
          <input type="checkbox" [checked]="selected.has(po.poNumber)" (change)="toggle(po.poNumber)" />
          <i class="fa t-checkbox-appearance"></i>
        </span>
        <ng-container *ngTemplateOutlet="poHead; context: { $implicit: po, statusChip: po.status === 'RELEASING' }"></ng-container>
        <ng-container *ngTemplateOutlet="poItems; context: { $implicit: po }"></ng-container>
      </label>

      <div *ngIf="!visiblePos.length" class="shila-po-empty">
        <i class="fas fa-file-invoice" aria-hidden="true"></i>
        <p>{{ (list.pos.length ? "translate.shilaPo.noMatch" : "translate.shilaPo.none") | translate }}</p>
        <p *ngIf="list.pos.length" class="shila-po-emptyHint">
          {{ "translate.shilaPo.filterHides" | translate: { count: list.pos.length } }}
          <button type="button" class="shila-po-link" (click)="filterBy('')">{{ "translate.shilaPo.clearFilter" | translate }}</button>
        </p>
      </div>
    </section>
  </div>

  <footer class="shila-po-foot">
    <span *ngIf="hiddenSelected" class="shila-po-hiddenSelected">
      <i class="fas fa-filter" aria-hidden="true"></i>
      {{ "translate.shilaPo.hiddenSelected" | translate: { count: hiddenSelected } }}
    </span>
    <button class="t-button--success import" [disabled]="busy || !selected.size" (click)="importSelected()">
      <ng-container *ngIf="selected.size; else importLabel">
        {{ "translate.shilaPo.importCount" | translate: { count: selected.size } }}
      </ng-container>
      <ng-template #importLabel>{{ "translate.shilaPo.import" | translate }}</ng-template>
    </button>
  </footer>
</div>

<!-- statusChip: an imported PO's status, or the mark of an open PO still being returned to Meimad's file (it stays selectable) -->
<ng-template #poHead let-po let-statusChip="statusChip">
  <span class="shila-po-patient">
    <span class="shila-po-field" [title]="'translate.shilaPo.patient' | translate">
      <i class="fas fa-user" aria-hidden="true"></i>
      <span>{{ po.patientName }} <span class="shila-po-fileNo">({{ po.patientFileNo }})</span></span>
    </span>
    <span *ngIf="statusChip" class="shila-po-status" [class.shila-po-releasing]="po.status === 'RELEASING'">
      <i *ngIf="po.status === 'RELEASING'" class="fas fa-undo-alt" aria-hidden="true"></i>
      {{ "translate.shilaPo.status." + po.status | translate }}
    </span>
  </span>
  <span class="shila-po-field shila-po-doctor" [title]="'translate.shilaPo.doctor' | translate">
    <i class="fas fa-user-md" aria-hidden="true"></i><span>{{ po.doctorName }}</span>
  </span>
  <span class="shila-po-field shila-po-date" [title]="'translate.shilaPo.date' | translate">
    <i class="far fa-calendar-alt" aria-hidden="true"></i>{{ po.poDate | date: "dd/MM/yy" }}
  </span>
  <span class="shila-po-field shila-po-number" [title]="'translate.shilaPo.poNumber' | translate">
    <i class="fas fa-file-invoice" aria-hidden="true"></i>{{ po.poNumber }}
  </span>
</ng-template>

<ng-template #poItems let-po>
  <span class="shila-po-items">
    <span *ngFor="let item of items.get(po.poNumber)" class="shila-po-item">
      <span class="shila-po-itemCode">{{ item.itemCode }}</span>
      <span class="shila-po-itemDescr">
        {{ item.itemDescr }}
        <span *ngIf="item.lineCount > 1" class="shila-po-muted" dir="ltr">×{{ item.lineCount }}</span>
      </span>
      <span class="shila-po-teeth" [title]="'translate.shilaPo.teeth' | translate">
        <i *ngIf="item.teeth.length" class="fas fa-tooth" aria-hidden="true"></i>
        <span *ngFor="let tooth of item.teeth" class="shila-po-tooth">{{ tooth }}</span>
      </span>
    </span>
  </span>
</ng-template>

<ng-template #candidateRows let-candidates>
  <button
    *ngFor="let candidate of candidates"
    type="button"
    class="shila-po-dentist-row"
    [class.is-selected]="pickedDoctorId === candidate.doctorId"
    (click)="pickDentist(candidate.doctorId)"
  >
    {{ candidate.wholeName }}
  </button>
</ng-template>
